// 上传图片到七牛云
import axios from 'axios'
const state = {
  qiniuData: {
    key: '',
    token: '',
    file: '',
    browseButton: ''
  }, // 七牛云token
  qiniuDataSaas: {
    key: '',
    token: '',
    file: '',
    browseButton: ''
  }, // 七牛云token
  upload_qiniu_url: 'https://up.qbox.me/',
  // 七牛云返回储存图片的子域名
  upload_qiniu_addr: 'http://file.jinglinshe.com/'
}

const mutations = {
  // 获取七牛云token and key
  GET_QINIUYUN_DATA(state, qiniuyunData) {
    state.qiniuData.key = qiniuyunData.key
    state.qiniuData.token = qiniuyunData.token
  },
  // 获取七牛云token and key
  GET_QINIUYUN_DATA2(state, qiniuyunData) {
    state.qiniuDataSaas.key = qiniuyunData.key
    state.qiniuDataSaas.token = qiniuyunData.token
  }
}
const actions = {
  // 获取七牛云token
  getQiniuyunToken({ commit }) {
    return new Promise((resolve, reject) => {
      axios.get('https://test.jinglinshe.com/saas/api/qiniu/token').then((response) => {
        commit('GET_QINIUYUN_DATA', response.data)
        resolve(response.data)
      })
    })
  },

  // 获取七牛云token
  getQiniuyunTokenSaas({ commit }) {
    return new Promise((resolve, reject) => {
      axios.get('https://test.jinglinshe.com/saas/api/qiniu/token').then((response) => {
        commit('GET_QINIUYUN_DATA2', response.data)
        resolve(response.data)
      })
    })
  },

  // 图片上传到七牛云
  uploadQiniuUp({ commit }, qiniuData) {
    return new Promise((resolve, reject) => {
      var formData = new FormData()
      formData.append('file', qiniuData.file)
      formData.append('key', qiniuData.key)
      formData.append('token', qiniuData.token)
      axios({
        method: 'post',
        url: 'http://upload.qiniup.com/',
        type: 'POST',
        data: formData
      }).then((response) => {
        resolve(response.data)
      })
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
